var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_dot",
    d: "M34.5 24.4c0 2-2.9 2-2.9 0 0-1.9 2.9-1.9 2.9 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M27.7 32.2c-.1 0-6.5 6-6.5 5.8v-5.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M19.7 24.5h8.1M15.3 18.1h17.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M28 32h7.2c2.6 0 4.7-2.1 4.7-4.7V15.2c0-2.6-2.1-4.7-4.7-4.7H19.6M8.3 21.9v5.4c0 2.6 2.1 4.7 4.7 4.7h8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M13.9 10.5H2.7M8.3 5v11.2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M13.9 10.5H2.7M8.3 5v11.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMessage);
export default __webpack_public_path__ + "static/media/addMessage.b45a0ab99ca793cf05c64d5a3907f331.svg";
export { ForwardRef as ReactComponent };